import React, { memo } from 'react';
import CdnImage, { cdnImageTypes } from '@prisjakt/ui-cdn-image';
import { FontEmphasis } from '@prisjakt/ui/text/variants';

import * as S from './styles';

export const { DEFAULT_STORE_LOGO_MAX_WIDTH, VARIANTS } = S;

type Props = {
  className?: string;
  featured?: boolean;
  hasImage: boolean;
  logoUrl?: string | null;
  name: string;
  newOfferItemExperiment?: boolean;
  showHighResolutionLogo?: boolean; // Making image half the size
  storeId: number | string;
  variant?: S.VARIANTS;
  width?: number;
};

const StoreLogo = ({
  className,
  featured = false,
  hasImage,
  logoUrl,
  name,
  newOfferItemExperiment = false,
  showHighResolutionLogo = false,
  storeId,
  variant = S.VARIANTS.DEFAULT,
  width = 88,
}: Props) => {
  const shouldRenderLogo =
    hasImage && (featured || variant === S.VARIANTS.CAMPAIGN);

  return (
    <S.StoreLogo
      className={className}
      logoWidth={width}
      showHighResolutionLogo={showHighResolutionLogo}
      showLogo={shouldRenderLogo}
      variant={variant}
      $newOfferItemExperiment={newOfferItemExperiment}
    >
      {shouldRenderLogo ? (
        <CdnImage
          type={cdnImageTypes.store}
          name={storeId}
          width={width}
          alt={name}
          logoUrl={logoUrl}
        />
      ) : (
        <S.StoreLogoText
          emphasis={
            newOfferItemExperiment ? FontEmphasis.MEDIUM : FontEmphasis.LOW
          }
        >
          {name}
        </S.StoreLogoText>
      )}
    </S.StoreLogo>
  );
};

export default memo(StoreLogo);
